// src/generated/noteLanding.ts
// **自動生成。手で編集しない。**
// 生成元: scripts/seo/note-landings.json
// 生成:   node scripts/hosting/generate-note-links.mjs --write
//
// note の記事key → 登録直後の「最初の1問」に使う科目。
// 科目を決められない記事（全科目の模試など）はここに出てこない＝既定に落ちる。

export const SUBJECT_BY_CAMPAIGN: Record<string, string> = {
  nc2109d89ff05: 'finance', // 診断士の財務・会計が苦手な人へ｜克服は「順番」で決まる4
  n1c00df2f556f: 'finance', // NPVとIRR、どっちを信じる？診断士試験の投資判断を数
  n83de9260705f: 'law', // 暗記3科目（経営法務・経営情報・中小企業政策）はいつから
  n09ad786ae1c8: 'finance', // 診断士2次・事例Ⅳが苦手な人へ｜計算より先に「指標選び」
  nf43ffdb9b188: 'case3', // 事例Ⅲ 与件の一文を答案の一文に変える——弱い答案と直し
};

/** 記事key → 短縮リンクの着地先。集計で「どこに着地したか」を突き合わせるのに使う。 */
export const LANDING_BY_CAMPAIGN: Record<string, string> = {
  nc2109d89ff05: '/mock/finance/',
  nef33c7ae26c0: '/mock/',
  n7bdd9af0a683: '/mock/',
  nfc1d9c0d713d: '/mock/2ji/',
  n1e855f6b2bb3: '/learn/',
  nbdbb3ee14250: '/mock/',
  n5df19ab1900f: '/mock/',
  n1c00df2f556f: '/learn/finance/npv-dcf/',
  n83de9260705f: '/learn/law/',
  nd11cfcb1e32e: '/mock/',
  n6ecc0e4d9d46: '/learn/',
  nb450534d0e91: '/mock/2ji/',
  n2f54adbe84e4: '/learn/',
  n09ad786ae1c8: '/drill/case4/',
  nf43ffdb9b188: '/learn/case3/',
};
